import type { Socket } from 'phoenix'
import { getValidDecodedToken } from 'src/utils/getValidDecodedToken'

/**
 * Halts the Phoenix socket's reconnect loop once its token has expired.
 *
 * The socket is created with a static token, and Phoenix re-dials with that same
 * token on every reconnect. Once the token expires, the socket-server rejects
 * every reconnect with `token_expired`, so Phoenix would otherwise loop forever
 * (~every 3s), hammering the server (this is what drives the socket-server's
 * connection-churn memory leak). When the token is no longer valid we disconnect
 * instead, which stops the loop. A still-valid token is left untouched so normal
 * transient-reconnect behaviour is preserved. The expired/anonymous session is
 * surfaced to the UI separately via `useGetCurrentPlayerToken`.
 *
 * Returns true if it stopped the socket (token expired/invalid), false otherwise.
 */
export const stopIfTokenExpired = (
  socket: Pick<Socket, 'disconnect'>,
  token: string
): boolean => {
  if (getValidDecodedToken(token)) return false
  socket.disconnect()
  return true
}
